import React, { ReactElement } from 'react';
import Input from '@ramsey-design-system/input';
import { FormikFormField } from '@frontman/rt-protections-ui';

function AgeStepForm(): ReactElement {
  return (
    <FormikFormField
      name="age"
      inputComponent={Input}
      id="age-step"
      rdsAttributes={{
        label: 'Your age',
        length: 'sm',
      }}
    />
  );
}

export { AgeStepForm };
